import React from 'react';
import './About.css'; // Import the CSS for styling
import stack from "./W (6).png"
import process from "./W (4).png"

const About = () => {
  return (
    <section className="about" id='howWeWork'>
      <div className="about-content">
        <h2 className="about-headline">What & How we <span className='orange-text'>Do</span></h2>
        <p className="about-text">
        We offer a curated collection of simple yet powerful apps to enhance every aspect of your digital life. Whether you're boosting productivity, seeking entertainment, or expressing creativity, BlackDoor has the tools you need. Explore our innovative products or contact us to bring your idea to life. Unlock your device’s full potential with us and elevate your everyday experiences.
        </p>
        <div className='about-2-process'>
          <img src={process} className='process' alt='BlackDoor process overview' />
            <img src={stack} className='stack' style={{opacity:"0.7"}} alt='BlackDoor technology stack' />
        </div>
      </div>
    </section>
  );
};

export default About;
